module.exports = __webpack_public_path__ + "static/media/a17_wba.dc05c113.png";